
import Vue from "vue";
import store from "@/store";
import router from "@/router";
import { validationMixin } from "vuelidate";
import AppLoading from "@/components/UI/AppLoading.vue";
import { required, minLength, minValue } from "vuelidate/lib/validators";

export default Vue.extend({
  name: "AdminAddProduct",
  mixins: [validationMixin],
  components: { AppLoading },

  props: {
    status: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      chosenFile: "" as string | FormData,
      chosenFiles: "" as string | FormData,
      defaultImage: require("@/assets/img/default-product.jpg"),
    };
  },
  methods: {
    submitContent() {
      const data = store.state.admin.landing.videoData;
      store.dispatch("admin/submitCreateVideo", data);
    },
  },
  computed: {
    languages(): any[] {
      let items: any[] = [
        {
          title: "انگلیسی",
          value: "En",
        },
        {
          title: "فارسی",
          value: "Fa",
        },
        {
          title: "عربی",
          value: "Ar",
        },
      ];
      return items;
    },

    pages(): any[] {
      let items: any[] = [
        {
          title: "صفحه اصلی",
          value: "landing",
        },
        {
          title: "درباره ما",
          value: "aboutUs",
        }
      ];
      return items;
    },

    position: {
      get(): string {
        return store.state.admin.landing.videoData.position;
      },
      set(value: string): void {
        store.dispatch("admin/updateVideoPage", value);
      },
    },

    video: {
      get(): string {
        return store.state.admin.landing.videoData.video;
      },
      set(value: string): void {
        store.dispatch("admin/updateVideoLink", value);
      },
    },

    videoError(): string[] {
      const errors: string[] = [];
      if (!this.$v.video?.$dirty) {
        return errors;
      }
      !this.$v.video.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    title: {
      get(): string {
        return store.state.admin.landing.videoData.title;
      },
      set(value: string): void {
        store.dispatch("admin/updateVideoDataTitle", value);
      },
    },

    titleError(): string[] {
      const errors: string[] = [];
      if (!this.$v.title?.$dirty) {
        return errors;
      }
      !this.$v.title.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    subTitle: {
      get(): string {
        return store.state.admin.landing.videoData.subTitle;
      },
      set(value: string): void {
        store.dispatch("admin/updateVideoDataSubTitle", value);
      },
    },

    subTitleError(): string[] {
      const errors: string[] = [];
      if (!this.$v.subTitle?.$dirty) {
        return errors;
      }
      !this.$v.subTitle.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    //   language: {
    //     get(): string {
    //       return store.state.admin.landing.homePage.aboutUs.language;
    //     },
    //     set(value: any): void {
    //       store.dispatch("admin/updateHomePageAboutUsLanguage", value);
    //     },
    //   },
    //   languageError(): string[] {
    //     const errors: string[] = [];
    //     if (!this.$v.language?.$dirty) {
    //       return errors;
    //     }
    //     !this.$v.language.required && errors.push("تکمیل این فیلد الزامی است");
    //     return errors;
    //   },
    description: {
      get(): string {
        return store.state.admin.landing.videoData.description;
      },
      set(value: string): void {
        store.dispatch("admin/updateVideoDataDescription", value);
      },
    },
    descriptionError(): string[] {
      const errors: string[] = [];
      if (!this.$v.description?.$dirty) {
        return errors;
      }
      !this.$v.description.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    isLoading(): boolean {
      return store.state.app.loading;
    },
  },
  mounted() {
    const id = this.$route.query.id;
    if (id) {
      store.dispatch("admin/updateProductCategory", id);
    }

    // console.log("create new video ===>", this.status);
  },
  validations: {
    title: {
      required,
    },
    subTitle: {
      required,
    },
    position: {
      required
    },
    video: {
      required,
    },
    description: {
      required,
    },
  },
});
